import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';

import styles from './RecordModal.module.scss';

const RecognitionRules = ({ action = 'LEFT' }) => {
  const { t } = useTranslation();

  const renderImage = () => {
    switch (action) {
      case 'LEFT':
        return (
          <div className={styles.face_rule_wrapper}>
            <Image
              src='/assets/turn-left.svg'
              alt={t('esim:recognitionRules.left')}
              title={t('esim:recognitionRules.left')}
              loading='lazy'
              width={60}
              height={60}
            />
            <p className={styles.detail}>{t('esim:recognitionRules.left')}</p>
          </div>
        );
      case 'RIGHT':
        return (
          <div className={styles.face_rule_wrapper}>
            <Image
              src='/assets/turn-right.svg'
              alt={t('esim:recognitionRules.right')}
              title={t('esim:recognitionRules.right')}
              loading='lazy'
              width={60}
              height={60}
            />
            <p className={styles.detail}>{t('esim:recognitionRules.right')}</p>
          </div>
        );
      case 'BLINK':
        return (
          <div className={styles.face_rule_wrapper}>
            <Image
              src='/assets/blink.svg'
              alt={t('esim:recognitionRules.blink')}
              title={t('esim:recognitionRules.blink')}
              loading='lazy'
              width={60}
              height={60}
            />
            <p className={styles.detail}>{t('esim:recognitionRules.blink')}</p>
          </div>
        );

      default:
        return (
          <div className={styles.face_rule_wrapper}>
            <Image
              src='/assets/smile.svg'
              alt={t('esim:recognitionRules.smile')}
              title={t('esim:recognitionRules.smile')}
              loading='lazy'
              width={60}
              height={60}
            />
            <p className={styles.detail}>{t('esim:recognitionRules.smile')}</p>
          </div>
        );
    }
  };
  return (
    <div itemScope itemType='https://schema.org/WebPage'>
      {renderImage()}
    </div>
  );
};

export default RecognitionRules;
